export default function UspSection() {
  const features = [
    {
      icon: 'ri-mic-line',
      title: 'Медицинский стендап',
      desc: '15-минутные паузы «Смехосоматика» между секциями — профилактика выгорания через смех',
    },
    {
      icon: 'ri-team-line',
      title: 'Междисциплинарный диалог',
      desc: 'Неврологи, кардиологи, педиатры за одним столом — редкий формат живого обмена опытом',
    },
    {
      icon: 'ri-robot-line',
      title: 'AI-консультант',
      desc: 'Чат-бот AI-болит во время обеда: протестируйте рекомендации, обсудите с коллегами',
    },
    {
      icon: 'ri-heart-line',
      title: 'Неформальная атмосфера',
      desc: 'Приходите с друзьями — кулуары, знакомства, живые разговоры без официоза',
    },
    {
      icon: 'ri-map-pin-line',
      title: 'СПб как часть программы',
      desc: 'Лавра в 5 минутах, Нева, Невский проспект рядом — город входит в культурную программу',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Практика, а не теория',
      desc: 'Алгоритмы и решения, которые работают уже завтра в вашей клинической практике',
    },
  ];

  return (
    <section id="about" className="py-20 md:py-28 bg-[#f5f2ed]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0f3d32] mb-4 leading-tight">
            Почему NeuroRussia — это не<br />«ещё одна конференция»
          </h2>
          <p className="text-xl md:text-2xl font-semibold text-[#c8963e]">
            Медицина + Юмор + Диалог = формула против выгорания
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white rounded-2xl p-8 hover:-translate-y-1 transition-all group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#1a6b5a]/10 rounded-2xl mb-6 group-hover:bg-[#1a6b5a] transition-colors">
                <i className={`${f.icon} text-2xl text-[#1a6b5a] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#0f3d32] mb-3">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
